import auth from '@/auth/index';
import axios, { axios as axios_new_api } from '@/store/config';
import {AUTH_STATUSES} from '@/config/constants'

export default {
  state: {
    authStatus: null,
    authStatusOnCall: null,
    SSOQueryString: auth.getSSOQueryString(),
    hasConfirmedMessagesOnboarding: null,
    applicantData: [],
    newUser: false,
    primaryEmailIsInUse: null,
    emailNames: null
  },

  getters: {
    authStatus: state => state.authStatus,
    authStatusOnCall: state => state.authStatusOnCall,
    SSOQueryString: state => state.SSOQueryString,
    primaryEmailIsInUse: state => state.primaryEmailIsInUse,
    emailNames: state => state.emailNames,
    hasConfirmedMessagesOnboarding: state => state.hasConfirmedMessagesOnboarding,
    applicantData: state => state.applicantData,
    isNewUser: state => state.newUser,
  },

  actions: {

    /**
     * Logga in med användarnamn / lösenord
     */
    loginWithUsernamePassword({commit, state}, credentials) {
      this.resetStore();
      this.cache.clear();
      // this.dispatch('setAuthStatus', AUTH_STATUSES.PENDING);

      return auth.loginWithUsernamePassword(credentials).then((res) => {
        this.dispatch('setAuthStatus', AUTH_STATUSES.LOGGEDIN);
        return res;
      }).catch((err) => {

        this.dispatch('setAuthStatus', AUTH_STATUSES.NOT_LOGGEDIN);

        return Promise.reject(err);
      })
    },

    /**
     * Be APIet om redirectURl för att loga in via BankID
     */
    loginBankIDStep1({commit, state}, data) {
      this.resetStore();
      this.cache.clear();

      // this.dispatch('setAuthStatus', AUTH_STATUSES.PENDING);

      return axios_new_api.post('bankid/auth', {
        ...data
      }).then((resp) => resp.data).catch((err) => {
        return Promise.reject(err);
      });
    },

    /**
     * Avnänd sessionId man fått från steg 1 för att logga in användaren.
     */
    loginBankIDStep2({commit, state}, {signal, sessionId}) {
      this.resetStore();
      this.cache.clear();

      // this.dispatch('setAuthStatus', AUTH_STATUSES.PENDING);
      return new Promise((resolve, reject) => {
        return axios.post('bankid/login', {
            sessionId
          },
          {signal})
          .then(response => {
            if (response.data.pending) {
              return resolve(response.data)
            }
            if (response.data.registrationRequired) {
              this.dispatch('setAuthStatus', AUTH_STATUSES.NOT_LOGGEDIN);
              return reject({response: {...response}, bankIdErrorMessage: 'Personnumret finns inte registrerat'});
            }
            auth.setAuthToken(response.data.access_token);
            this.dispatch('setAuthStatus', AUTH_STATUSES.LOGGEDIN);
            return resolve(response.data);
          }).catch((err) => {
            reject(err);
          });
      })
    },
    async checkAuthStatus({ commit }) {
      const result = await auth.checkAuth(); // must return true or false
      commit('setAuthStatus', result);
    },

    async checkAuthStatusOnCall({ commit }) {
      const result = await auth.checkAuthOnCall(); // must return true or false
      console.log("checkAuthStatusOnCall", result)
      commit('setAuthStatusOnCall', result);
    },
    /**
     * Avnänd sessionId man fått från steg 1 för att hämta code & email
     */
    getTokenForChangingEmail({commit, state}, {signal, sessionId}) {
      this.resetStore();
      this.cache.clear();

      // this.dispatch('setAuthStatus', AUTH_STATUSES.PENDING);
      return new Promise((resolve, reject) => {
        return axios_new_api.post('bankid/verifyIdentity', {
            sessionId
          },
          {signal})
          .then(response => {
            if (response.data.registrationRequired) {
              this.dispatch('setAuthStatus', AUTH_STATUSES.NOT_LOGGEDIN);
              return reject({response: {...response}, bankIdErrorMessage: 'Personnumret finns inte registrerat'});
            }
            if (response.data.pending) {
              return resolve(response.data)
            }
            return resolve(response.data);
          });
      })
    },

    // hämta ssoquery. kräver att man redan är inloggad
    loginSsoMe({commit, state}) {
      return auth.fetchSSOQueryString().then((queryString) => {
        this.commit('setSSOQueryString', queryString);
      })
    },

    /**
     * Loggar in via SSO som angiven användare.
     *
     * @param { username, hash, timestamp } credentials
     */
    loginSsoUser({commit, state}, credentials) {
      this.resetStore();
      this.cache.clear();
      // this.dispatch('setAuthStatus', AUTH_STATUSES.PENDING);

      return auth.loginWithHash(credentials).then(() => {
        this.dispatch('setAuthStatus', AUTH_STATUSES.LOGGEDIN);
      }).catch((err) => {

        this.dispatch('setAuthStatus', AUTH_STATUSES.NOT_LOGGEDIN);

        return Promise.reject(err);
      })
    },

    /**
     * Logga ut.
     *
     * Skickar logga ut req, ändra authStatus, rensa store
     */
    logout({commit, state}) {
      auth.logout().then(() => {
        this.commit('setSSOQueryString', null);
        this.resetStore();
        this.cache.clear();
        this.dispatch('setAuthStatus', AUTH_STATUSES.NOT_LOGGEDIN);
      })
    },

    /**
     * Sätter statusen för inloggad / inte inloggad
     */
    setAuthStatus({commit, state}, status) {

      // if(typeof status === 'undefined')
      //   status = auth.checkAuth();

      commit('setAuthStatus', status);
    },

    setAuthStatusOnCall({commit}, status) {
      commit('setAuthStatusOnCall', status);
    },

    handleUnauthorized({commit, state}, data) {
      data = data || {};


      if (data && data.code == "wrongCredentials") return data.description;

      const errors = data.errors || [];

      const errorDetail = errors.find(x => x.code === 'inactiveUser' || x.code === 'accountLocked')
      const isSessionExpired = data.code === 'invalid' && (data.description || "").toLocaleLowerCase() === 'session is invalid or has expired';

      if (errorDetail) {
        return errorDetail.description
      } else if(!isSessionExpired) {
        return this.getters.webapp_config.msg.login_failure;
      }
    },
    setPrimaryEmailIsInUse({commit, state}, primaryEmailIsInUse) {
       commit('setPrimaryEmailIsInUse', primaryEmailIsInUse);
    },
    setEmailNames({commit, state}, emailNames) {
      commit('setEmailNames', emailNames);
    },
    setHasConfirmedMessagesOnboarding({commit, state}, val) {
      commit('setHasConfirmedMessagesOnboarding', val);
    },
    setNewUser({commit, state}, val) {
      commit('setNewUser', val);
    },
    setApplicantAuthData({commit, state}, val) {
      commit('setApplicantData', val);
    },
  },

  mutations: {
    setAuthStatus(state, status) {
      state.authStatus = status;
    },
    setAuthStatusOnCall(state, status) {
      state.authStatusOnCall = status;
    },
    setSSOQueryString(state, queryString) {
      state.SSOQueryString = queryString;
    },
    setPrimaryEmailIsInUse(state, primaryEmailIsInUse) {
      state.primaryEmailIsInUse = primaryEmailIsInUse;
    },
    setEmailNames(state, emailNames) {
      state.emailNames = emailNames;
    },
    setHasConfirmedMessagesOnboarding(state, val) {
      state.hasConfirmedMessagesOnboarding = val;
    },
    setNewUser(state, val) {
      state.newUser = val;
    },
    setApplicantData(state, val) {
      state.applicantData = val;
    },
  }
}
